import { RoleMasterForm } from "../../../models/config/RoleMaster";
import { useCompanyMaster } from "../../../queries";
import { useCallback, useMemo } from "react";
import { useMenuMaster } from "../../LegacyMenuMasterConfig/queries";
import { MenuMaster } from "../../../models/config/MenuMaster";
import { Button, ButtonGroup, Spinner, Table } from "react-bootstrap";
import { FaRegEdit, FaTimesCircle } from "react-icons/fa";
import Select from 'react-select';

export type RoleMasterTableProps = {
    roleMasterForms?: RoleMasterForm[];
    isPending?: boolean;
    onEdit?: (roleMasterForm: RoleMasterForm) => void;
    onDelete?: (roleMasterForm: RoleMasterForm) => void;
};

export const RoleMasterTable = (props: RoleMasterTableProps) => {
    const { isPending, roleMasterForms, onEdit, onDelete } = props;

    const { data: companyMaster } = useCompanyMaster();
    const companyMasterMap = useMemo(
        () => new Map(companyMaster?.map(company => [company.sid, company])),
        [companyMaster]
    );

    const { data: menuMaster = [] } = useMenuMaster();

    const getMenuMasterLabel = useCallback(
        (menuMaster: MenuMaster) => `${menuMaster.id}: ${menuMaster.menu_name}`,
        []
    );

    const getMenuMasterValue = useCallback(
        (menuMaster: MenuMaster) => menuMaster.id,
        []
    );

    return (
        <div className="mt-3">
            <Table className="table-bordered table-hover custom-table-list table-responsive-lg" size="sm">
                <thead>
                    <tr style={{ width: '100%' }} className="text-center table-active thead-light require-field">
                        <th style={{ width: '5%', top: -1, position: 'sticky', zIndex: 1 }} />
                        <th style={{ width: '15%', top: -1, position: 'sticky', zIndex: 1 }}>Company Name</th>
                        <th style={{ width: '10%', top: -1, position: 'sticky', zIndex: 1 }}>Role ID</th>
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Permissions</th>
                    </tr>
                </thead>
                <tbody>
                    {isPending ? (
                        <tr>
                            <td colSpan={4} style={{ background: "rgba(209, 250, 221, 1)", color: "black", fontSize: '10pt', textAlign: "center" }}>
                                <Spinner animation="border" size="sm" />{' '}Loading...
                            </td>
                        </tr>
                    ) : !roleMasterForms?.length ? (
                        <tr>
                            <td colSpan={4} style={{ background: "#b7b7a4", color: "black", fontSize: '10pt', textAlign: "center" }}>No Data.</td>
                        </tr>
                    ) : (
                        roleMasterForms.map((roleMasterForm, index) => (
                            <tr key={index}>
                                <td className="text-center" style={{ width: '5%' }}>
                                    <ButtonGroup>
                                        <Button
                                            size="sm"
                                            variant="info"
                                            onClick={() => onEdit?.(roleMasterForm)}
                                        >
                                            <FaRegEdit />
                                        </Button>
                                        <Button
                                            size="sm"
                                            variant="danger"
                                            onClick={() => onDelete?.(roleMasterForm)}
                                        >
                                            <FaTimesCircle />
                                        </Button>
                                    </ButtonGroup>
                                </td>
                                <td className="text-center">
                                    {roleMasterForm.sid === '*'
                                        ? roleMasterForm.sid
                                        : companyMasterMap.get(roleMasterForm.sid)?.company_name}
                                </td>
                                <td>{roleMasterForm.id}</td>
                                <td>
                                    <Select
                                        isMulti
                                        isDisabled
                                        options={menuMaster}
                                        value={roleMasterForm.allowMenus
                                            .slice(0)
                                            .sort((a, b) => a.menu_name.localeCompare(b.menu_name))}
                                        getOptionLabel={getMenuMasterLabel}
                                        getOptionValue={getMenuMasterValue}
                                    />
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        </div>
    );
};
